import { render, staticRenderFns } from "./partnerLogin.vue?vue&type=template&id=0f9cb184&scoped=true&"
import script from "./partnerLogin.vue?vue&type=script&lang=js&"
export * from "./partnerLogin.vue?vue&type=script&lang=js&"
import style0 from "./partnerLogin.vue?vue&type=style&index=0&id=0f9cb184&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9cb184",
  null
  
)

export default component.exports